<template>
  <Departments />
</template>

<script>
import Departments from "@/components/Departments/index.vue";

export default {
  components: {
    Departments,
  },
};
</script>

<style></style>
